import React, { useCallback, useEffect, useState } from "react";
import {useParams } from "react-router-dom";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import getFileType, {
  checkImage,
} from "../../../helper/ImageFormat";
import { ImageLink } from "../../../utils/constants";
import { fetchData } from "../../../utils/apiUtils";
import debounce from "lodash.debounce";
import Spinner from "../../../Components/spinner";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import CustomPagination from "../../../helper/Pagination";

const CataloguesProduct = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [productData, setproductData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const totalPages = Math.ceil(totalCount / perPage);
  const fetchProductData = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      catalogue_id: id,
      search: searchQuery,
    };
    await fetchData(
      `catalogue-product`,
      requestData,
      setproductData,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

  const debouncedFetcCategory = useCallback(debounce(fetchProductData, 1000), [
    perPage,
  ]);

  useEffect(() => {
    debouncedFetcCategory(1, search);
  }, [perPage, search]);

  const Tableheader = [
    "Image",
    "Title",
    "SKU",
    "Quantity",
    "Average Price",
    "Single Price",
    "Discount",
    "Show Single",
  ];

  const handleFancyBox = (images) => {
    Fancybox.show(
      images
        .filter((img) => getFileType(img) === "image")
        .map((img) => ({
          src: ImageLink(img),
          type: "image",
        })),
      {
        Thumbs: {
          autoStart: true,
        },
      }
    );
  };

  const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchProductData(page);
  }
 };
  return (
    <>
      <div className="content-wrapper">
        <div
          className="page-header mt-5"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="custom-page-title">Catalogue Products</h3>
        </div>

        <div
          className="d-flex justify-content-between mb-2"
          style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
        >
          <PerPageSelect value={perPage} onChange={setPerPage}/>

          <div style={{ display: "flex", gap: "20px" }}>
           <TableSearch value={search} onChange={setSearch} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="pb-20 table-responsive ">
                  <table className="custom-table table table-striped" id="categoryTable">
                    <thead>
                      <tr>
                        {Tableheader &&
                          Tableheader.length > 0 &&
                          Tableheader.map((item, index) => (
                            <th className="font-weight-bold col-2 text-center" key={index}>
                              {item}
                            </th>
                          ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : productData.length > 0 ? (
                        productData.map((data, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleFancyBox(data.image);
                              }}
                            >
                              {checkImage(data?.image[0])}
                            </td>

                            <td
                              className="text-center col-1 "
                              style={{
                                fontFamily: "'Roboto', sans-serif",
                                wordWrap: "break-word",
                              }}
                            >
                              {data.name.slice(0, 15)}...
                            </td>
                            <td
                              className="text-center col-3 bold-text "
                              style={{
                                fontFamily: "'robot',sans-serif",
                              }}
                            >
                              {data?.sku}
                            </td>

                            <td
                              className="text-center col-3 bold-text "
                              style={{
                                fontFamily: "'robot',sans-serif",
                              }}
                            >
                              {data?.quantity}
                            </td>

                            <td
                              className="text-center col-3 bold-text "
                              style={{
                                fontFamily: "'robot',sans-serif",
                              }}
                            >
                              {data?.average_price ? data?.average_price : "-"}
                            </td>

                            <td
                              className="text-center col-3 bold-text "
                              style={{
                                fontFamily: "'robot',sans-serif",
                              }}
                            >
                              {data?.retail_price ? data?.retail_price : "-"}
                            </td>

                            <td
                              className="text-center col-3 bold-text "
                              style={{
                                fontFamily: "'robot',sans-serif",
                              }}
                            >
                              {data?.retail_discount ? `${data.retail_discount} %` : "-"}
                            </td>

                            <td>
                              {data?.showInSingle ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: "rgba(99, 221, 99, 0.9)",
                                    padding: "5px",
                                    borderRadius: "50%",
                                    height: "20px",
                                    width: "20px",
                                  }}
                                >
                                  <i
                                    className="fa-solid fa-check"
                                    style={{
                                      cursor: "pointer",
                                      textAlign: "center",
                                      color: "#fff",
                                      marginTop: "3px",
                                      fontSize: "13px",
                                    }}
                                  />
                                </div>
                              ) : (
                                <span>-</span>
                              )}
                            </td>
{/* 
                            <td>
                              <ViewButton handleRedirect={handleRedirect} id={data?.id} />
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <h4>No data available</h4>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              {
          productData && productData.length > 0 && <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
        }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CataloguesProduct;
